export default [
  {
    path: '/data-connector-setup',
    name: 'data-connector-setup-view',
    component: () => import('@/views/dataConnector/data-connector-setup.vue'),
  },
]
